import { render, staticRenderFns } from "./customMultiSelect.vue?vue&type=template&id=f4c443fa"
import script from "./customMultiSelect.vue?vue&type=script&lang=js"
export * from "./customMultiSelect.vue?vue&type=script&lang=js"
import style0 from "./customMultiSelect.vue?vue&type=style&index=0&id=f4c443fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports